import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import Detail from './components/Detail'
import Analytics from './components/Analytics'

const LivechatModule: RouteObject = {
    path: 'livechat',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'analytics',
            element: <Analytics />,
        },
        {
            path: ':roomId',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default LivechatModule
